<section class="cmn-innerpage-wrapper">
  <div class="head">
    <h1>{{ posterId ? "Edit " : "Add new " }}Poster</h1>
  </div>
  <div class="form-wrapper" *ngIf="!contentLoading">
    <form id="translation" [formGroup]="mainForm">
      <div class="grid-wrapper">
        <label class="full-width-Wrapper block-pointer">
          <span>Poster Contents</span>

          <div class="faq-container">
            <div class="lang-wrapper">
              <label>
                <mat-form-field appearance="fill">
                  <mat-select (selectionChange)="onLanguageSelect($event)" formControlName="langId"
                    placeholder="Language">
                    <mat-option *ngFor="let lang of languages" [value]="lang.id" [disabled]="isLangUsed(lang.id)">
                      {{ lang.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="mainForm.get('langId')?.hasError('required')">Language is required</mat-error>
                </mat-form-field>
              </label>
            </div>
            <div class="faqWrapper">
              <label class="block-pointer">
                <span>Title</span>
                <mat-form-field>
                  <input type="text" matInput placeholder="Title" formControlName="title" />
                  <mat-error *ngIf="mainForm.get('title')?.hasError('required')">Title is required</mat-error>
                  <mat-error *ngIf="mainForm.get('title')?.hasError('onlySpaces')">Title name cannot be
                    empty</mat-error>
                  <mat-error *ngIf="
                      mainForm.get('title')?.hasError('onlySpecialAlphaChars')
                    ">Title name cannot contain only special chacaters and
                    numbers</mat-error>
                </mat-form-field>
              </label>
              <label>
                <span>Description</span>
                <mat-form-field class="example-full-width">
                  <textarea type="text" matInput placeholder="Description" formControlName="description"></textarea>
                  <mat-error *ngIf="mainForm.get('description')?.hasError('required')">Description is
                    required</mat-error>
                  <mat-error *ngIf="mainForm.get('description')?.hasError('onlySpaces')">Description name cannot be
                    empty</mat-error>
                  <mat-error *ngIf="
                      mainForm
                        .get('description')
                        ?.hasError('onlySpecialAlphaChars')
                    ">Description name cannot contain only special chacaters and
                    numbers</mat-error>
                </mat-form-field>
              </label>
            </div>
            <div class="add-translation-btn full-width-Wrapper">
              <p [style.visibility]="
                  posterTranslations.length === 0 ? 'visible' : 'hidden'
                ">
                Add at least one translation to save
              </p>

              <button type="button" (click)="addPosterTable()" class="add-button  unblock-pointer">
                 Add
              </button>

            </div>
          </div>
        </label>
      </div>
    </form>
    <div class="tableWrapper" *ngIf="posterTranslations.length">
      <table>
        <thead>
          <tr>
            <th>No</th>
            <th>Language</th>
            <th>Title</th>
            <th>Description</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let poster of posterTranslations; let i = index">
            <tr>
              <td>{{ i + 1 }}</td>
              <td>{{ getLanguageName(poster.langId) }}</td>
              <td>{{ poster.title }}</td>
              <td>{{ poster.description.slice(0, 60) }}</td>
              <td>
                <div class="actionWrapper">
                  <div *ngIf="poster.langId !== 1" class="actionItem" (click)="removePosterTranslation(i)">
                    <img src="../../../assets/images/icons/icon-delete.svg" alt="Delete" />
                  </div>
                  <div class="actionItem" (click)="editPosterTranslation(i)">
                    <img src="../../../assets/images/icons/icon-edit.svg" alt="Edit" />
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
    <div class="grid-wrapper tags-image-section">
      <label>
        <span>Tags</span>
        <div class="tags-collection">
          <div class="tags-item" *ngFor="let tag of TAGS" [ngClass]="{
              'tags-choosed': isTagSelected(tag),
              'tags-item': !isTagSelected(tag)
            }" (click)="toggleTag(tag)" style="cursor: pointer">
            <h6>{{ tag.name }}</h6>
          </div>
        </div>
      </label>
      <label class="block-pointer">
        <span>Upload Image or PDF</span>
        <div class="borderedWrapper">
          <div class="fileSection">
            <label for="imageFile" class="unblock-pointer">
              Choose A File
              <input #imagefileInput type="file" name="imageFile" id="imageFile" (change)="onImageUpload($event)"
                accept=".jpeg, .jpg, .png, .webp, .pdf" />
            </label>
            <div class="uploadedFiles" *ngIf="imageFileName">
              <ul>
                <li>
                  <h6>{{ imageFileName }}</h6>
                  <img src="../../../assets/images/icons/icon-close.svg" alt="Remove" style="cursor: pointer"
                    class="unblock-pointer" (click)="clearImageUpload()" />
                </li>
              </ul>
            </div>
          </div>
          <h6>
            File should be in JPG, JPEG, PNG or PDF format and not exceed 20MB
            in size.
          </h6>
        </div>
      </label>
    </div>
    <div style="padding-top: 15px" class="submit-btn-wrapper">
      <button (click)="onCancel()" type="button" class="cmn-cancel-btn">
        Cancel
      </button>
      <button [disabled]="isSubmitting || !posterTranslations.length" type="submit" (click)="onSave()"
        class="cmn-next-btn">
        <span>Save</span>
      </button>
    </div>
  </div>
  <app-content-loader [visible]="contentLoading"></app-content-loader>
</section>

<app-fullscreen-loader [visible]="imageUploading || loading" [message]="
    imageUploading ? 'Uploading file, please wait...' : 'Saving, Please wait'
  ">
</app-fullscreen-loader>
